import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NewsItemType } from '../types';

interface NewsItemProps {
  item: NewsItemType;
  index: number;
}

export function NewsItem({ item, index }: NewsItemProps) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-white rounded-xl shadow-lg overflow-hidden"
    >
      <div className="relative h-48">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center gap-4 mb-4">
          <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
            {item.category}
          </span>
          <div className="flex items-center text-gray-500 text-sm">
            <Calendar className="h-4 w-4 mr-1" />
            {item.date}
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {item.title}
        </h3>
        <p className="text-gray-600 mb-4">{item.description}</p>
        <Link 
          to={`/news/${item.slug}`}
          className="inline-flex items-center text-green-600 hover:text-green-700"
        >
          Read more
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </motion.article>
  );
}